import { render, staticRenderFns } from "./droppoint.vue?vue&type=template&id=004ecdfd&scoped=true&"
import script from "./droppoint.vue?vue&type=script&lang=js&"
export * from "./droppoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004ecdfd",
  null
  
)

export default component.exports